import { Button, Caption, FormControl, Input } from '@farol-ds/react'

import { parseErrorMessage } from '../../../utils/parseErrorMessage'
import { LoginCard } from '../../login-card'
import { PasswordField } from '../../password-field'
import { ChangePasswordSubmitInput, useChangePasswordForm } from '../hooks'
import styles from './change-password.module.scss'

export type { ChangePasswordSubmitInput }

export interface ChangePasswordProps {
  email?: string
  fullName?: string
  isLoading?: boolean
  error?: string
  onSubmit: (input: ChangePasswordSubmitInput) => Promise<void> | void
  onCancel?: () => void
}

export function ChangePassword(props: ChangePasswordProps) {
  const { email, fullName, isLoading, error, onSubmit, onCancel } = props

  const { currentPassword, newPassword, confirmPassword, handleSubmit } = useChangePasswordForm({
    onValidSubmit: onSubmit,
    fullName,
    email,
  })

  const parsedError = error ? parseErrorMessage(error) : null
  const header = {
    title: 'Alterar senha',
    ...(parsedError && {
      errorMessage: {
        title: parsedError.title,
        description: parsedError.description,
      },
    }),
  }

  return (
    <LoginCard header={header} hideCloseButton>
      <form onSubmit={handleSubmit} className={styles.form} noValidate>
        <input autoComplete="username" hidden name="username" value={email ?? ''} readOnly />

        <FormControl error={!!currentPassword.error}>
          <FormControl.Label>Senha atual</FormControl.Label>
          <Input
            type="password"
            name="current-password"
            value={currentPassword.value}
            onChange={(e) => currentPassword.onChange(e.target.value)}
            onBlur={currentPassword.onBlur}
            autoComplete="current-password"
            disabled={isLoading}
          />
          {currentPassword.error && (
            <FormControl.ErrorMessage>{currentPassword.error}</FormControl.ErrorMessage>
          )}
        </FormControl>

        <PasswordField
          label="Nova senha"
          value={newPassword.value}
          onChange={newPassword.onChange}
          onBlur={newPassword.onBlur}
          disabled={isLoading}
          fullName={fullName}
          email={email}
          error={newPassword.error}
        />

        <PasswordField
          label="Confirme a nova senha"
          value={confirmPassword.value}
          onChange={confirmPassword.onChange}
          onBlur={confirmPassword.onBlur}
          disabled={isLoading}
          error={confirmPassword.error}
          hideRequirements
          hideStrengthIndicator
        />

        <Caption className={styles.captionSessions}>
          Isso encerrará todas as suas sessões ativas.
        </Caption>

        <div className={styles.actions}>
          {onCancel && (
            <Button type="button" kind="tertiary" disabled={isLoading} onClick={onCancel}>
              Cancelar
            </Button>
          )}
          <Button type="submit" kind="primary" loading={isLoading}>
            Alterar
          </Button>
        </div>
      </form>
    </LoginCard>
  )
}
